/*!
 * Copyright © 2005-2024 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Alfresco Example Content Application
 *
 * This file is part of the Alfresco Example Content Application.
 * If the software was purchased under a paid Alfresco license, the terms of
 * the paid license agreement will prevail. Otherwise, the software is
 * provided under the following open source license terms:
 *
 * The Alfresco Example Content Application is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The Alfresco Example Content Application is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * from Hyland Software. If not, see <http://www.gnu.org/licenses/>.
 */

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { map } from 'rxjs/operators';

import { CREATE_PDF_ACTION, CreatePdfAction, MOVE_JOBDOCUMENT_ACTION, MoveJobdocumentAction, ViewInTabAction, JOBDOCUMENT_VIEWINTAB_ACTION, OpenWithBluebeamAction, JOBDOCUMENT_OPEN_WITH_BLUEBEAM_ACTION, COPY_JOBDOCUMENT_ACTION, CopyJobdocumentAction } from '../actions/jobdocuments.actions';
import { BluebeamService } from '../services/bluebeam.service';
import { CarlisleContentManagementService } from '../services/carlisle-content-management.service';

@Injectable()
export class JobDocumentsEffects {
  constructor(
    private actions$: Actions,
    private carlisleContentService: CarlisleContentManagementService,
    private bluebeamService: BluebeamService,
    private router: Router) {}

  createPdf$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<CreatePdfAction>(CREATE_PDF_ACTION),
        map((action) => {
          if (action.payload) {
          this.carlisleContentService.createPdfRendition({entry: action.payload});
          }
        })
      ),
    { dispatch: false }
  );

  moveJobdocument$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<MoveJobdocumentAction>(MOVE_JOBDOCUMENT_ACTION),
        map((action) => {
          if (action.payload) {
            this.carlisleContentService.moveJobDocument({entry: action.payload});
          }
        })
      ),
    { dispatch: false }
  );

  viewInTab$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<ViewInTabAction>(JOBDOCUMENT_VIEWINTAB_ACTION),
        map((action) => {
          if (action.payload) {
            let selection = action.payload;
            let id: string;
            let parentId: string | undefined;

            if (selection.nodeType === 'app:filelink') {
              id = selection.properties['cm:destination'];
            } else {
              id = selection.id;
              parentId =selection.parentId;
            }

            var url = this.router.serializeUrl(
              // this.router.createUrlTree(['jobdocuments/aev/preview', id])
              this.router.createUrlTree(['view/tab', parentId, id],  {
                queryParams: {}
              })
            );
            url = url.replace("view/tab", "jobdocuments/#/view/tab");
            //console.log("Launch tab", url);
            //window.open(url, '_blank'); // Open the URL in a new tab
            window.open(url, '_blank'); // Open the URL in a new tab

          }
        })
      ),
    { dispatch: false }
  );

  openBluebeam$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<OpenWithBluebeamAction>(JOBDOCUMENT_OPEN_WITH_BLUEBEAM_ACTION),
        map((action) => {
          if (action.payload) {
            this.bluebeamService.onActionEditInBluebeam(action.payload);
          }
        })
      ),
    { dispatch: false }
  );

  copyJobdocument$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<CopyJobdocumentAction>(COPY_JOBDOCUMENT_ACTION),
        map((action) => {
          if (action.payload) {
            this.carlisleContentService.copyJobDocument({entry: action.payload});
          }
        })
      ),
    { dispatch: false }
  );




}
